import type { DatePickerDateObject } from '../types';

export const isSameDateObject = (
  a: DatePickerDateObject | null,
  b: DatePickerDateObject | null,
) =>
  !!a &&
  !!b &&
  a.range === b.range &&
  a.start?.getTime() === b.start?.getTime() &&
  a.end?.getTime() === b.end?.getTime();

export function getSelectedDisabledFields(
  filteredData,
  selectedProperties,
  returnType,
  robotName?: string | null,
) {
  const disabledFields = filteredData
    ? filteredData.flatMap((itemData) => {
        return itemData.values
          .filter((val) => {
            return val.dayDisabled
              ? robotName
                ? !!selectedProperties?.[
                    `${val.dataLocationInStore} (${robotName})`
                  ]
                : !!selectedProperties?.[val.dataLocationInStore]
              : false;
          })
          .map((i) => {
            return returnType === 'dataLocationInStore'
              ? i.dataLocationInStore
              : i.name;
          });
      })
    : [];
  return disabledFields;
}
